import { cn } from '@/common';
import React from 'react';

const NotAvailableText = (props: { className?: string }) => {
  return <span className={cn('text-gray-300 italic', props?.className)}>N/A</span>;
};

export default NotAvailableText;
